import { Nullable } from '../../types/common'
import Card from '../card/card'
import QuickViewComponent from '../quick-view/quick-view'

class VerticalProductCard extends Card {
  quickViewTrigger: Nullable<HTMLElement>
  quickView: QuickViewComponent

  constructor() {
    super()

    this.quickViewTrigger = this.querySelector(
      '[data-product-card-quick-view-button]',
    )
    this.quickView = document.getElementById('Quick-view') as QuickViewComponent
  }

  connectedCallback(): void {
    this.addEventListener('mouseenter', this.handleMouseEnter)

    if (this.quickViewTrigger) {
      this.quickViewTrigger.addEventListener(
        'click',
        this.handleQuickViewTriggerClick,
      )
    }
  }

  disconnectedCallback(): void {
    this.removeEventListener('mouseenter', this.handleMouseEnter)

    if (this.quickViewTrigger) {
      this.quickViewTrigger.removeEventListener(
        'click',
        this.handleQuickViewTriggerClick,
      )
    }
  }

  handleMouseEnter = (): void => {
    const url = this.dataset.url
    const id = this.dataset.id

    if (!this.quickView) {
      return
    }

    if (url && id) {
      this.quickView.requestProductFromUrl(url, id)
    }
  }

  handleQuickViewTriggerClick = (): void => {
    const url = this.dataset.url

    if (!this.quickView) {
      return
    }

    if (url) {
      this.quickView.openAndRenderProductByUrl(url)
    }
  }
}

export default VerticalProductCard
